<template>
  <content-panel class="template-config-page">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini">
          <el-form-item label="店铺">
            <el-select
              v-model="searchForm.storeIds"
              multiple
              clearable
              collapse-tags
              placeholder="请选择店铺"
              style="width: 320px"
            >
              <el-option
                v-for="item in storeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button size="mini" @click="handleReset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel>
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="handleAdd">新增模板</el-button>
      </template>

      <el-table
        :data="tableData.records"
        border
        size="mini"
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="storeName" label="店铺名称" min-width="160" />
        <el-table-column label="模板预览图" width="130">
          <template slot-scope="{ row }">
            <el-image
              class="preview-thumb"
              :src="row.previewUrl"
              :preview-src-list="[row.previewUrl]"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="templateName" label="模板名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="resolutionText" label="模板底图分辨率(px)" min-width="180" />
        <el-table-column prop="groupNames" label="模板活动文案组" min-width="240" show-overflow-tooltip />
        <el-table-column prop="updater" label="更新人" min-width="120" />
        <el-table-column prop="updateTime" label="更新时间" min-width="180" />
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <template v-slot:footer>
        <div class="pagination-wrap">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-size="tableData.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          />
        </div>
      </template>
    </table-panel>

    <store-decoration-template-dialog
      :visible.sync="dialogVisible"
      :edit-data="currentRow"
      @confirm="handleDialogConfirm"
    />
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import mockService from './mockService'
import StoreDecorationTemplateDialog from './components/dialogs/StoreDecorationTemplateDialog.vue'

export default {
  name: 'StoreDecorationTemplateConfig',
  components: {
    StoreDecorationTemplateDialog
  },
  mixins: [pagePathMixin],
  data () {
    return {
      loading: false,
      dialogVisible: false,
      storeOptions: [],
      currentRow: null,
      searchForm: {
        storeIds: []
      },
      tableData: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.initOptions()
    this.fetchList()
  },
  methods: {
    initOptions () {
      mockService.getStoreOptions().then(res => {
        this.storeOptions = res.data || []
      })
    },
    fetchList () {
      this.loading = true
      mockService.getStoreDecorationTemplateList({
        storeIds: this.searchForm.storeIds,
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize
      }).then(res => {
        this.tableData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch () {
      this.tableData.pageNum = 1
      this.fetchList()
    },
    handleReset () {
      this.searchForm.storeIds = []
      this.tableData.pageNum = 1
      this.fetchList()
    },
    handleSizeChange (pageSize) {
      this.tableData.pageNum = 1
      this.tableData.pageSize = pageSize
      this.fetchList()
    },
    handleCurrentChange (pageNum) {
      this.tableData.pageNum = pageNum
      this.fetchList()
    },
    handleAdd () {
      this.currentRow = null
      this.dialogVisible = true
    },
    handleEdit (row) {
      this.loading = true
      mockService.getStoreDecorationTemplateDetail({ id: row.id }).then(res => {
        this.currentRow = JSON.parse(JSON.stringify(res.data || row))
        this.dialogVisible = true
      }).finally(() => {
        this.loading = false
      })
    },
    handleDelete (row) {
      this.$confirm(`确认删除模板“${row.templateName}”吗？`, '提示', { type: 'warning' }).then(() => {
        return mockService.deleteStoreDecorationTemplate({ id: row.id })
      }).then(res => {
        this.$message.success(res.message)
        this.fetchList()
      }).catch(() => {})
    },
    handleDialogConfirm (payload) {
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      mockService.saveStoreDecorationTemplate(payload).then(res => {
        this.$message.success(res.message)
        this.dialogVisible = false
        this.fetchList()
      })
      .finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.template-config-page
  height calc(100vh - 85px)

.preview-thumb
  width 72px
  height 72px
  object-fit cover
  border-radius 4px
  border 1px solid #ebeef5
  cursor pointer

.danger-text
  color #F56C6C

.pagination-wrap
  display flex
  justify-content flex-end
  padding-top 10px
</style>
